import type { FC, HTMLAttributes } from "react";

import classnames from "classnames";
import dompurify from "isomorphic-dompurify";

import { useGetSubscriptionConfigurationsQuery } from "@jti/store/slices/subscriptionApiSlice";
import { formatDate, useTranslations } from "@jti/ui";

import styles from "./SubscriptionBillingDisclaimer.module.scss";

const { sanitize } = dompurify;

type SubscriptionBillingDisclaimerProps = HTMLAttributes<HTMLParagraphElement>;

export const SubscriptionBillingDisclaimer: FC<SubscriptionBillingDisclaimerProps> = ({ className, ...props }) => {
  const { __ } = useTranslations();
  const { data: subscriptionConfig, isLoading, error } = useGetSubscriptionConfigurationsQuery();

  if (isLoading || !subscriptionConfig?.nextChargeAt) {
    return null;
  }

  const formattedBillingDate = formatDate(subscriptionConfig.nextChargeAt);
  const billingDateText = error
    ? __("summarySubscription.nextBillingError")
    : __("summarySubscription.nextBilling", [formattedBillingDate]);

  return (
    <p
      className={classnames(styles.disclaimer, className)}
      data-testid="subscription-billing-disclaimer"
      dangerouslySetInnerHTML={{
        __html: sanitize(billingDateText),
      }}
      {...props}
    ></p>
  );
};
